<template>
  <div>
    <v-data-iterator
      id="data-table"
      ref="dataIterator"
      data-component-id="dataIterator"
      class="overflow-hidden transparent"
      :items="paginatedItems"
      :items-per-page="itemsPerPage"
      hide-default-footer
    >
      <template #header>
        <slot name="top"></slot>
      </template>
      <template #default="{ items }">
        <div
          class="
            persistent-scrollbar
            overflow-x-auto overflow-hidden
          "
          style="display: grid; gap: 16px;"
        >
          <component
            :is="template"
            v-for="(item, itemIndex) in items"
            :key="itemIndex"
            :item="item"
            :show-assign-offer-button="showAssignOfferButton"
          />
        </div>
      </template>
      <template #no-data>
        <slot name="no-data">
          <div
            class="
              d-flex justify-center align-center
              rounded-lg py-4
              white font-weight-medium grey--text
            "
            style="height: 48px;"
          >
            Aucune donnée disponible
          </div>
        </slot>
      </template>
    </v-data-iterator>
    <v-pagination
      v-if="showFooter && list.length > itemsPerPage"
      v-model="page"
      :length="pageCount"
      total-visible="5"
      class="py-6"
    />
  </div>
</template>

<script>
import ListItemForApplications from '@/components/table/components/ListItemForApplications.vue';
import ListItemForCandidates from '@/components/table/components/ListItemForCandidates.vue';

export default {
  name: 'DataIterator',
  components: { ListItemForApplications, ListItemForCandidates },
  props: {
    template: {
      type: String,
      default: 'ListItemForApplications'
    },
    list: {
      type: Array,
      default: () => []
    },
    tableConfig: {
      type: Object,
      default: () => ({})
    },
    actionsConfig: {
      type: Object,
      default: () => ({})
    },
    showAssignOfferButton: {
      type: Boolean,
      default: false
    },
    showFooter: {
      type: Boolean,
      default: false
    },
    itemsPerPage: {
      type: Number,
      default: 10
    }
  },
  data () {
    return { isLoading: [], page: 1 };
  },
  computed: {
    paginatedItems () {
      const start = (this.page - 1) * this.itemsPerPage;
      return this.list.slice(start, start + this.itemsPerPage);
    },
    pageCount () {
      return Math.ceil(this.list.length / this.itemsPerPage) || 1;
    }
  }
};
</script>
